import { render, staticRenderFns } from "./custConvertChannelSourceListCmr.vue?vue&type=template&id=89d8f680&scoped=true&"
import script from "./custConvertChannelSourceListCmr.vue?vue&type=script&lang=js&"
export * from "./custConvertChannelSourceListCmr.vue?vue&type=script&lang=js&"
import style0 from "./custConvertChannelSourceListCmr.vue?vue&type=style&index=0&id=89d8f680&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d8f680",
  null
  
)

export default component.exports